import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./Customer.module.css";
import plus from "../../../Assets/plus.svg"
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import EyeIcon from "../../../Assets/new-eye.svg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../Web Pages/Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import logo from "../../../Assets/rotating-logo.png";








const Customer = () => {
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [accName, setAccName] = useState('');
  const [accNo, setAccNo] = useState('');
  const [bankName, setBankName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showEdit, setShowEdit] = useState(false);
const [editCustomer, setEditCustomer] = useState(null);
const [balance, setBalance] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);

const handleShowEdit = (customer) => {
  setEditCustomer(customer); // load selected customer
  setShowEdit(true);
};

const handleCloseEdit = () => {
  setShowEdit(false);
  setEditCustomer(null);
};
  const handleShow = () => setShow(true);
const handleShow2 = (customer) => {
  setSelectedCustomer(customer); // save selected customer
  setShow2(true); // open modal
};
  const handleShow1 = () => setShow1(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  

  const fetchSearch = async (searchTerm) => {
    setSearchLoading(true);
    try {
      let res;
      if (searchTerm.trim() === "") {
        res = tableData;
      } else {
        const response = await axios.get(`${BASE_URL}/customer/search-customers`, {
          params: { variable: searchTerm },
          headers
        });
        res = response.data?.data;
      }
      setSearchedResult(res);
      console.log(res, "searched");

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setSearchedResult([]);
      }
    } finally {
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.trim() !== "") {
        fetchSearch(searchTerm);
      } else {
        setSearchedResult([]); // clear results if empty
      }
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler); // cancel on new keystroke
    };
  }, [searchTerm]);

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;

  const createCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to create this customer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true); // show rotating logo overlay
        try {
          const response = await axios.post(
            `${BASE_URL}/customer/add`,
            {
              name: fullName,
              email: email,
              phone: phone,
              address: address,
              office_address: office_address,
              account_name: accName,
              account_number: accNo,
              bank_name: bankName,
            },
            { headers }
          );

          handleCustomers();
          handleClose();

          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); // hide rotating logo
        }
      }
    });
  };

    const uploadExcel = async () => {
   Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this document?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Upload",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUploading(true);
      try {
        const formData = new FormData();
      formData.append('file', selectedFile[0]);
     
  
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${bearer}`,
      };
  
     
      const response = await axios.post(`${BASE_URL}/customer/import-customer?category_id=${1}`,
        formData,
        { headers }
      );
  handleClose1();
  handleCustomers();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
  
      console.log(response.data.message);
       } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }
  
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
  
      console.error(error);
    } finally {
          setUploading(false);
        }
      }
    });
  };

   const handleFileChange = (event) => {
    const files = event.target.files;
    const fileList = Array.from(files);
    setSelectedFile(fileList);
    
  };

   const updateCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this customer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);

    try {
        const response = await axios.post(`${BASE_URL}/customer/update`,
        {
          name: editCustomer.fullName1,
          id: editCustomer.id, 
          email: editCustomer.email1,
          phone: editCustomer.phone1,
          account_name: editCustomer.accName1, 
          account_number: editCustomer.accNo1, 
          bank_name: editCustomer.bankName1, 
          balance: editCustomer.balance, 
          
        },
        { headers }
      );

      handleCustomers();
      handleCloseEdit();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      // console.log(response.data);
     } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }
  
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
  
      console.error(error);
    } finally {
          setLoading(false);
        }
      }
    });
  };




  return (
    <div >
      <HeaderNav />

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Full Name"
                // autoFocus
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Address"
                // autoFocus
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Office Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter office Address"
                // autoFocus
                value={office_address}
                onChange={(e) => setOfficeAddress(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Phone Number"
                // autoFocus
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Email Address"
                // autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Account Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Name"
                // autoFocus
                value={accName}
                onChange={(e) => setAccName(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Number"
                // autoFocus
                value={accNo}
                onChange={(e) => setAccNo(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Bank Name"
                // autoFocus
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>






        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button className={classes.loanBtn} variant="primary" onClick={createCustomer}>
            Create Customer
          </Button>
        </Modal.Footer>
      </Modal>
         <Modal show={show1} style={{ fontSize: 18, fontWeight: 600 }} onHide={handleClose1} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title>Upload Customer</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ fontSize: 14}}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Excel File</Form.Label>
                            <Form.Control
                              type="file"
                              accept=".xlsx, .xls, .csv"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>







                      <Modal.Footer>
                        <Button variant="danger" onClick={handleClose1}>
                          Go back
                        </Button>
                        <Button className={classes.loanBtn} variant="primary" onClick={uploadExcel}>
                          
                            
                           Upload
                         
                        </Button>
                      </Modal.Footer>
                    </Modal>
<Modal show={show2} onHide={handleClose2} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>View User</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {selectedCustomer ? (
      <Form style={{ fontSize: 14 }}>
        <Form.Group className="mb-3">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            type="text"
            value={selectedCustomer.name || ""}
            readOnly
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="text"
            value={selectedCustomer.email || ""}
            readOnly
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            value={selectedCustomer.phone || ""}
            readOnly
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Address</Form.Label>
          <Form.Control
            type="text"
            value={selectedCustomer.address || ""}
            readOnly
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Office Address</Form.Label>
          <Form.Control
            type="text"
            value={selectedCustomer.office_address || ""}
            readOnly
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Bank Details</Form.Label>
          <Form.Control
            type="text"
            value={`${selectedCustomer.account_name || ""} - ${selectedCustomer.account_number || ""} (${selectedCustomer.bank_name || ""})`}
            readOnly
          />
        </Form.Group>
      </Form>
    ) : (
      <p>No customer selected</p>
    )}
  </Modal.Body>
</Modal>
<Modal show={showEdit} onHide={handleCloseEdit} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>
      Edit Customer
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {editCustomer && (
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.name}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, name: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Address</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.address}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, address: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Office Address</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.office_address}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, office_address: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.phone}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, phone: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.email}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, email: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Outstanding Balance</Form.Label>
<Form.Control
  name="total-amount"
  type="text"
  value={editCustomer.balance || ""}
  onChange={(e) =>
    setEditCustomer({ ...editCustomer, balance: e.target.value })
  }
  style={{
    textAlign: "right",
    fontWeight: "600",
  }}
/>

          <Form.Label>Account Name</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.account_name}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, account_name: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Account Number</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.account_number}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, account_number: e.target.value })
            }
          />
          <div style={{ marginTop: 10 }} />

          <Form.Label>Bank Name</Form.Label>
          <Form.Control
            type="text"
            value={editCustomer.bank_name}
            onChange={(e) =>
              setEditCustomer({ ...editCustomer, bank_name: e.target.value })
            }
          />
        </Form.Group>
      </Form>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={handleCloseEdit}>
      Cancel
    </Button>
    <Button
      className={classes.loanBtn}
      variant="primary"
      onClick={() => updateCustomer(editCustomer)}
    >
      Update Customer
    </Button>
  </Modal.Footer>
</Modal>


      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Customers</h3>
        <p className={classes.prgText}>Manage your customer's transactions, customer's invoices, and payments.</p>
        <div className={classes.subContainer}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            alignItems: 'center'
          }}>
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search customers..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>

         
          <div className={classes.statCount}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Customers</p>
              <p className={classes.txtHds}>
                {statLoading ? (
                  <Skeleton width={80} height={20} />
                ) : (
                  formatStat(stat?.total_number_of_customers)
                )}
              </p>
            </div>
             </div>
             {tableData?.length > 0 && (
  <button className={classes.downBtn}>
    <img src={download} alt="download" /> Download Excel
  </button>
)}
          </div>
          <div className={classes.threeBtns}>
            <a style={{marginLeft: 10}} href="https://account-api.patna.ng/api/v1/download-customer-template" download>
            <button className={classes.downBtn}>
              <img src={download} alt="download" /> Download Template
            </button>
            </a>

            <button className={classes.downBtn} onClick={handleShow1}>
              <img src={upload} alt="upload" /> Upload Customer
            </button>
            <button className={classes.loanBtn} onClick={handleShow}>
              <img src={plus} alt="plus" /> New Customer
            </button>
          </div>

        </div>
        <div className={classes.tableContainer}>
          {/* <div style={{display: "flex", gap: 10, alignItems: 'center'}}> */}
           
          {/* </div> */}
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Province Code</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Created At</th>
                <th>Outstanding Balance</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {benLoading ? (
                // Skeleton loading
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(7).fill().map((_, i) => (
                      <td key={i}>
                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : (isSearching ? (
                searchedResult.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
                      No matching customers found
                    </td>
                  </tr>
                ) : (

                  searchedResult.map((item, index) => (
                    <tr key={index}>
                      <td className={classes.textby}>{index + 1}</td>
                      <td className={classes.textby}>{item.employee_no}</td>
                      <td className={classes.textby}>{item.name}</td>
                      <td className={classes.textby}>{item.email}</td>
                      <td className={classes.textby}>{item.phone}</td>
                      <td className={classes.textby}>{formatDate(item.created_at)}</td>
                      <td className={classes.textby} style={{ textAlign: "right" }}>
                        {parseFloat(item.balance).toLocaleString("en-US", {
                          minimumIntegerDigits: 1,
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td className={classes.btnAction}>
                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                          onClick={() => handleShow2(item)}
                        >
                          <img src={EyeIcon} />
                        </button>
                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                          onClick={() => handleShowEdit(item)}
                        >
                          <img src={PencilIcon} />
                        </button>

                        <button
                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        >
                          <img src={DeleteIcon} />
                        </button>
                      </td>
                    </tr>
                  ))
                )
              ) : (
                // Default tableData
                tableData.map((item, index) => (
                  <tr key={index}>
                    <td className={classes.textby}>{index + 1}</td>
                    <td className={classes.textby}>{item.employee_no}</td>
                    <td className={classes.textby}>{item.name}</td>
                    <td className={classes.textby}>{item.email}</td>
                    <td className={classes.textby}>{item.phone}</td>
                    <td className={classes.textby}>{formatDate(item.created_at)}</td>
                    <td className={classes.textby} style={{ textAlign: "right" }}>
                      {parseFloat(item.balance).toLocaleString("en-US", {
                        minimumIntegerDigits: 1,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                    <td className={classes.btnAction}>
                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        onClick={() => handleShow2(item)}
                      >
                        <img src={EyeIcon} />
                      </button>
                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        onClick={() => handleShowEdit(item)}
                      >
                        <img src={PencilIcon} />
                      </button>

                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                      >
                        <img src={DeleteIcon} />
                      </button>
                    </td>
                  </tr>
                ))
              ))}
            </tbody>

          </table>
          {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default Customer